(() => {
  const addBusinessDays = (startDate, days) => {
    const date = new Date(startDate);
    let remaining = days;

    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }

    return date;
  };

  const formatDate = (date) =>
    new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    }).format(date);

  const updateEstimatedDelivery = (delivery) => {
    const arrival = delivery.querySelector('[data-feltwhimsy-delivery-arrival]');
    if (!arrival) return;

    const makingDays = Number(delivery.dataset.makingDays || 7);
    const shippingMinDays = Number(delivery.dataset.shippingMinDays || 5);
    const shippingMaxDays = Number(delivery.dataset.shippingMaxDays || 10);
    const today = new Date();
    const earliestArrival = addBusinessDays(today, makingDays + shippingMinDays);
    const latestArrival = addBusinessDays(today, makingDays + shippingMaxDays);

    arrival.textContent = `${formatDate(earliestArrival)} - ${formatDate(latestArrival)}`;
    arrival.setAttribute('aria-label', `Estimated arrival between ${formatDate(earliestArrival)} and ${formatDate(latestArrival)}`);
  };

  document.querySelectorAll('[data-feltwhimsy-delivery]').forEach(updateEstimatedDelivery);
})();
